module.exports = __webpack_public_path__ + "img/nhs.19030527.png";